// src/pages/ContentDetail/components/activity/FluencyActivity.js
import React from 'react';
import { Box, Typography, Divider, alpha } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import MarginBottomContainer from '../../../../components/containers/MarginBottomContainer';
import ReadableText from '../../../../components/text/ReadableText';

const FluencyActivity = ({ activity }) => {
  const theme = useTheme();
  
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom color="text.primary">
        {activity.activityTitle}
      </Typography>

      <MarginBottomContainer>
        {activity.content.paragraphs.map((paragraph, index) => {
          // Check if readable value exists and is not empty
          const hasReadable = paragraph.readable?.value && paragraph.readable.value.trim() !== '';
          
          return (
            <Box key={index} sx={{ mb: 3 }}>
              {/* Regular text */}
              <Typography variant="body1" paragraph color="text.primary">
                {paragraph.raw}
              </Typography>
              
              {hasReadable && (
                <>
                  <Divider sx={{ 
                    my: 1, 
                    borderColor: alpha(theme.palette.common.white, 0.1) 
                  }} />
                  <Box sx={{ ml: 1 }}>
                    <ReadableText text={paragraph.readable} />
                  </Box>
                </>
              )}
            </Box>
          );
        })}
      </MarginBottomContainer>
    </Box>
  );
};

export default FluencyActivity;